import { css, hasOverflow } from 'shared/utils/dom';
import { createOverFlowRuler } from 'shared/hooks/useScale';
/**
 * Calculate how much font-size should
 * be scaled down to prevent overflow.
 */
export const calculateOverflowFreeScale = (element, restStateStyles, autoFill) => {
    const [ruler, removeRuler] = createOverFlowRuler(element, restStateStyles);
    const initialScale = autoFill === 'yes' && !hasOverflow(ruler) ? 15 : 1;
    const scale = findScale(ruler, initialScale, restStateStyles.fontSize || '2vw');
    removeRuler();
    return scale;
};
/**
 * Scale font-size by 10% until there is no overflow.
 */
const findScale = (element, currentScale = 1, originalFontSize) => {
    const fontSize = `${parseFloat(originalFontSize) * currentScale}vw`;
    css(element, { fontSize });
    return hasOverflow(element)
        ? findScale(element, currentScale * 0.95, originalFontSize)
        : currentScale;
};
